import { StyleSheet, View } from 'react-native';

import { Skeleton } from 'components/ui/skeleton';
import { primitive } from 'styles/constants';

export const LoyaltySkeletonHeader = () => {
  return (
    <View style={styles.container}>
      <Skeleton shape="circle" style={{ width: 30, height: 30 }} />
      <Skeleton shape="rectangle" style={{ marginLeft: 16, width: 132, height: 16 }} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    height: 65,
    alignItems: 'center',
    flexDirection: 'row',
    width: '100%',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: primitive.$blackOpacity10,
    paddingHorizontal: 15,
    marginVertical: 12,
  },
});
